var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect } from "react";
import { ReactSVG } from "react-svg";
import ReactMapGL, { NavigationControl, Popup } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "mapbox-gl";
import MapboxWorker from "worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker";
mapboxgl.workerClass = MapboxWorker;
import { useEnvContext } from "@gw/env-context";
import { NSSpecies } from "@gw/types";
import { imgs } from "@gw/theming";
import { MapStyled } from "./MapStyled";
import FarmerImage from "../FarmerImage";
import Markers from "./Markers";
var Map = function (_a) {
    var mapRef = _a.mapRef, viewport = _a.viewport, onViewportChange = _a.onViewportChange, farmers = _a.farmers, activeFarmer = _a.activeFarmer, setActiveFarmer = _a.setActiveFarmer, setSlideIndex = _a.setSlideIndex, isMobile = _a.isMobile;
    var _b = useEnvContext(), imgsFolder = _b.imgsFolder, mapboxToken = _b.mapboxToken;
    var _c = useState(false), loaded = _c[0], setLoaded = _c[1];
    useEffect(function () {
        var farmListNavItem = document.querySelector(".item-active");
        if (!isMobile && farmListNavItem) {
            farmListNavItem.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    }, [isMobile, activeFarmer, farmers]);
    return (React.createElement(MapStyled, { ref: mapRef },
        React.createElement(ReactMapGL, __assign({}, viewport, { width: "100%", height: "100%", maxZoom: 12, mapStyle: "mapbox://styles/mapbox/outdoors-v11", onViewportChange: function (viewState) { return onViewportChange(viewState); }, mapboxApiAccessToken: mapboxToken, onLoad: function () { return setLoaded(true); } }),
            React.createElement(NavigationControl, { showCompass: false, className: "nav-control" }),
            loaded && (React.createElement(Markers, { farmers: farmers, activeFarmer: activeFarmer, setActiveFarmer: setActiveFarmer, setSlideIndex: setSlideIndex, isMobile: isMobile })),
            loaded && !isMobile && activeFarmer && (React.createElement(Popup, { latitude: activeFarmer.location.coordinates[0], longitude: activeFarmer.location.coordinates[1], closeButton: false, tipSize: 7, offsetLeft: -3, offsetTop: -38, onClose: function () { return setActiveFarmer(null); } },
                React.createElement(FarmerImage, { logoImg: activeFarmer.logo_img_url }),
                React.createElement("div", null,
                    React.createElement("h3", null, activeFarmer.name),
                    React.createElement("p", { className: "species" }, activeFarmer.species_data
                        .map(function (_a) {
                        var _b;
                        var species = _a.species;
                        return (_b = NSSpecies.labels.speciesLabels.kelp[species]) === null || _b === void 0 ? void 0 : _b.name;
                    })
                        .join(" • ")),
                    activeFarmer.city && activeFarmer.state && (React.createElement("p", { className: "location" },
                        React.createElement(ReactSVG, { className: "icon-place", src: imgsFolder + "/" + imgs.icons.iconPlaceGreen, wrapper: "span" }), activeFarmer.city + ", " + activeFarmer.state))))))));
};
export default Map;
//# sourceMappingURL=Map.js.map